

// import { useState, useEffect, useRef } from "react"
// import { ThreeDots } from "react-loader-spinner"
// import "@fortawesome/fontawesome-free/css/all.min.css"

// const VetLearnChatbot = () => {
//   const [isOpen, setIsOpen] = useState(false)
//   const [messages, setMessages] = useState([])
//   const [inputText, setInputText] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [userName, setUserName] = useState("")
//   const [askingName, setAskingName] = useState(true)
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
//   const [isSpeaking, setIsSpeaking] = useState(false)
//   const [showSuggestions, setShowSuggestions] = useState(false)
//   const [typingEffect, setTypingEffect] = useState({ active: false, text: "", fullText: "", speed: 30 })
//   const messagesEndRef = useRef(null)
//   const chatContainerRef = useRef(null)

//   // VetLearn features data organized by category
//   const vetLearnFeatures = {
//     "Course Creation and Management": [
//       "Creation of expert-designed modules tailored to real-world technical courses in dairy, poultry, sheep & goat, swine and companion animal health",
//       "Modification of existing courses with practical, research-backed content from industry leaders",
//       "Deletion of obsolete content to keep the platform relevant and updated with latest industry practices",
//       "Preview feature to view courses from a learner's perspective before publishing to ensure quality delivery",
//     ],
//     "Learning Paths and Skill Development": [
//       "Creation of personalized learning journeys for entrepreneurship, productivity, and sustainability in animal health industries",
//       "Skill-based assessments and interactive modules designed to boost learner capabilities",
//       "Flexibility to adjust learning paths based on individual career and business objectives",
//       "Continuous upskilling programs for professional growth in livestock and companion animal sectors",
//     ],
//     "Progress Tracking and Analytics": [
//       "Comprehensive tracking of learning progress, completion rates, and assessment results",
//       "Data-driven insights to identify strengths, bridge gaps, and align learning with professional goals",
//       "Performance analytics for both learners and administrators to monitor development",
//       "Personalized recommendations based on learning patterns and career objectives",
//     ],
//     "Content Delivery and Accessibility": [
//       "24/7 access to interactive training resources with user-friendly platform design",
//       "Support for multiple content formats including practical case studies and research-driven materials",
//       "Mobile-responsive interface ensuring seamless learning experience across all devices",
//       "Integration with external tools and resources for comprehensive learning support",
//     ],
//     "Assessments and Certifications": [
//       "Practical assessments based on real-world scenarios in animal healthcare and nutrition",
//       "Professional certification programs recognized in the livestock and companion animal industry",
//       "Skill-based evaluations aligned with industry standards and best practices",
//       "Achievement recognition system to support career advancement and professional growth",
//     ],
//     "Community and Collaboration": [
//       "Connect and communicate with peers to learn from everyone's experience",
//       "Expert-led discussions and knowledge sharing sessions",
//       "Collaborative learning environment fostering professional networking",
//       "Access to industry professionals and seasoned experts for guidance and mentorship",
//     ],
//     "Entrepreneurship and Business Development": [
//       "Entrepreneurial readiness programs for livestock and companion animal industry opportunities",
//       "Business development modules focusing on making livestock farming simple and profitable",
//       "Industry insights and market analysis for informed decision-making",
//       "Practical business tools and case-based approaches for real-time problem solving",
//     ],
//     "Specialized Industry Focus": [
//       "Comprehensive coverage of dairy, poultry, sheep & goat, swine, and companion animal health sectors",
//       "Expert guidance from professionals with decades of hands-on experience",
//       "Research-backed content supported by leading veterinary experts and industry practitioners",
//       "Focus on enhancing pet health and happiness of pet parents in companion animal sector",
//     ],
//   }

//   // Quick reply suggestions
//   const suggestions = [
//     "Course Access",
//     "Learning Paths",
//     "Certifications",
//     "Industry Focus",
//     "Entrepreneurship",
//     "Progress Tracking",
//   ]

//   // Generate questions about VetLearn features
//   const generateQuestions = () => {
//     const questions = [
//       `Hello ${userName}! Welcome to VetLearn - your gateway to animal health expertise. Which area interests you most: Dairy, Poultry, Companion Animals, or Entrepreneurship?`,
//       `Great choice! What's your current role in the animal health industry? Are you a farmer, veterinarian, student, or looking to start your own venture?`,
//       `${userName}, what specific skills would you like to develop? We offer practical training in animal nutrition, health management, or business development.`,
//       `How important is hands-on, practical learning to you? Our courses are designed with real-world case studies and field experience.`,
//       `Would you be interested in earning professional certifications that are recognized in the livestock and companion animal industry?`,
//       `Are you looking to connect with other professionals and experts in the animal health field for collaborative learning?`,
//       `What's your primary goal: enhancing your current skills, starting an animal health business, or advancing your career?`,
//       `How do you prefer to learn? We offer 24/7 access with flexible scheduling, interactive modules, and expert-led sessions.`,
//       `Would you like to track your progress and receive personalized recommendations based on your learning journey?`,
//       `Are you interested in our specialized programs for making livestock farming more profitable and sustainable?`,
//     ]
//     return questions
//   }

//   // Generate detailed responses about VetLearn features
//   const generateResponseForFeature = (feature) => {
//     const featureResponses = {
//       course:
//         "VetLearn offers expert-designed courses tailored to real-world applications in dairy, poultry, sheep & goat, swine, and companion animal health. All content is backed by research and taught by industry professionals with decades of hands-on experience.",
//       "learning path":
//         "Our personalized learning paths are designed to build entrepreneurship, boost productivity, and ensure sustainability in animal health industries. We use data-driven insights to create customized journeys that align with your career and business objectives.",
//       certification:
//         "VetLearn provides professional certifications recognized in the livestock and companion animal industry. Our achievement recognition system supports career advancement and validates your expertise in animal healthcare and nutrition.",
//       entrepreneurship:
//         "We focus on building entrepreneurial readiness with comprehensive business development modules. Our goal is to make livestock farming simple and profitable while enhancing pet health and happiness of pet parents.",
//       industry:
//         "VetLearn specializes in dairy, poultry, sheep & goat, swine, and companion animal health sectors. Our content is developed by experts who blend veterinary sciences, animal nutrition, and business development expertise.",
//       progress:
//         "Our platform tracks learning progress, completion rates, and assessment results to offer personalized insights. These analytics help identify strengths, bridge gaps, and align learning with your professional goals.",
//       practical:
//         "Every course emphasizes practical outcomes with real-world case studies and research conducted by leading veterinary experts. We blend experience with evidence-based knowledge for meaningful learning that enhances on-the-job performance.",
//       access:
//         "VetLearn provides 24/7 access to interactive training resources through a secure, user-friendly platform. You can learn anytime, anywhere with our mobile-responsive interface and comprehensive learning support.",
//       community:
//         "Connect, communicate, and learn from peers while gaining insights from industry experts. Our collaborative environment fosters professional networking and knowledge sharing in the animal health community.",
//       analytics:
//         "We enable data-driven learning with comprehensive analytics that track your performance and provide personalized recommendations. This empowers both learners and administrators to make informed decisions about professional development.",
//       support:
//         "For any support or assistance, you can contact us at vetlearn@vetrinahealthcare.com or call us at +91 8600844450. Our team is always ready to help you with your learning journey.",
//       contact:
//         "You can reach out to us for support at vetlearn@vetrinahealthcare.com or call us at +91 8600844450. We're here to assist you with any questions about VetLearn platform and courses.",
//       help: "Need help? Contact our support team at vetlearn@vetrinahealthcare.com or call +91 8600844450. We provide comprehensive support for all your learning needs on the VetLearn platform.",
//       default:
//         "VetLearn is a hybrid learning platform designed to transform animal health education. We offer comprehensive training in dairy, poultry, sheep & goat, swine, and companion animal sectors, focusing on practical skills, entrepreneurship, and professional growth. For support, contact us at vetlearn@vetrinahealthcare.com or +91 8600844450. How can I help you explore our specific features?",
//     }

//     // Check which feature is mentioned
//     const lowerFeature = feature.toLowerCase()
//     for (const [key, response] of Object.entries(featureResponses)) {
//       if (lowerFeature.includes(key)) {
//         return response
//       }
//     }
//     return featureResponses.default
//   }

//   // Typing effect for bot messages
//   useEffect(() => {
//     if (typingEffect.active && typingEffect.text.length < typingEffect.fullText.length) {
//       const timer = setTimeout(() => {
//         setTypingEffect((prev) => ({
//           ...prev,
//           text: prev.fullText.substring(0, prev.text.length + 1),
//         }))
//       }, typingEffect.speed)
//       return () => clearTimeout(timer)
//     } else if (typingEffect.active && typingEffect.text.length === typingEffect.fullText.length) {
//       setTypingEffect((prev) => ({ ...prev, active: false }))
//       // After typing is complete, show suggestions if appropriate
//       if (!askingName && currentQuestionIndex === 1) {
//         setShowSuggestions(true)
//       }
//     }
//   }, [typingEffect, askingName, currentQuestionIndex])

//   // Scroll to bottom when messages change
//   useEffect(() => {
//     if (messagesEndRef.current) {
//       messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
//     }
//   }, [messages, typingEffect.text])

//   // Initialize speech synthesis voices
//   useEffect(() => {
//     // Force voice list loading
//     speechSynthesis.getVoices()
//   }, [])

//   const toggleChat = () => {
//     setIsOpen(!isOpen)
//     if (!isOpen) {
//       // Reset conversation when opening
//       setMessages([])
//       setAskingName(true)
//       setUserName("")
//       setCurrentQuestionIndex(0)
//       setShowSuggestions(false)
//     }
//   }

//   const speak = (text) => {
//     if (isSpeaking) {
//       speechSynthesis.cancel()
//     }
//     setIsSpeaking(true)
//     const utterance = new SpeechSynthesisUtterance(text)
//     utterance.lang = "en-US"
//     const voices = speechSynthesis.getVoices()
//     const femaleVoice = voices.find(
//       (voice) =>
//         voice.name.includes("Female") ||
//         voice.name.includes("Google US English Female") ||
//         voice.name.includes("Samantha"),
//     )
//     if (femaleVoice) {
//       utterance.voice = femaleVoice
//     }
//     utterance.onend = () => {
//       setIsSpeaking(false)
//     }
//     speechSynthesis.speak(utterance)
//   }

//   useEffect(() => {
//     if (isOpen) {
//       const greetingMessage = {
//         text: "Hello! I am Ms.Kawan from VetLearn - your comprehensive learning platform for animal health and nutrition. What is your name?",
//         sender: "bot",
//       }
//       setMessages([greetingMessage])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: greetingMessage.text,
//         speed: 30,
//       })
//       speak(greetingMessage.text)
//     }
//   }, [isOpen])

//   const processNameAndContinue = () => {
//     if (inputText.trim() === "") return

//     // Add user's message to the chat
//     const newMessage = {
//       text: inputText,
//       sender: "user",
//     }
//     setMessages((prevMessages) => [...prevMessages, newMessage])

//     // Store the name
//     setUserName(inputText)
//     setAskingName(false)
//     setInputText("")

//     // Send a welcome message and the first question
//     setTimeout(() => {
//       const welcomeMessage = {
//         text: `Nice to meet you, ${inputText}! Welcome to VetLearn - where we empower learning and enable growth in animal health industries. I'd like to understand your learning goals better.`,
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, welcomeMessage])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: welcomeMessage.text,
//         speed: 30,
//       })
//       speak(welcomeMessage.text)

//       setTimeout(() => {
//         const firstQuestion = {
//           text: generateQuestions()[0],
//           sender: "bot",
//         }
//         setMessages((prevMessages) => [...prevMessages, firstQuestion])
//         // Start typing effect for first question
//         setTypingEffect({
//           active: true,
//           text: "",
//           fullText: firstQuestion.text,
//           speed: 30,
//         })
//         speak(firstQuestion.text)
//         setCurrentQuestionIndex(1)
//       }, 2000)
//     }, 1000)
//   }

//   const askNextQuestion = () => {
//     const questions = generateQuestions()
//     if (currentQuestionIndex < questions.length) {
//       const nextQuestion = {
//         text: questions[currentQuestionIndex],
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, nextQuestion])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: nextQuestion.text,
//         speed: 30,
//       })
//       speak(nextQuestion.text)
//       setCurrentQuestionIndex(currentQuestionIndex + 1)
//       setShowSuggestions(false)
//     } else {
//       // If we've gone through all questions, provide a summary
//       const summaryMessage = {
//         text: `Thank you for sharing your interests, ${userName}! Based on our conversation, I can help you discover the perfect VetLearn solution. Our platform offers 24/7 access to expert-designed courses, practical assessments, and professional certifications. For support, contact us at vetlearn@vetrinahealthcare.com or +91 8600844450. Would you like me to guide you to our course catalog or help you get started with a specific learning path?`,
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, summaryMessage])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: summaryMessage.text,
//         speed: 30,
//       })
//       speak(summaryMessage.text)
//     }
//   }

//   const sendMessage = () => {
//     if (!inputText.trim()) return

//     setShowSuggestions(false)

//     // Handle the name question separately
//     if (askingName) {
//       processNameAndContinue()
//       return
//     }

//     // Normal message flow
//     const newMessage = {
//       text: inputText,
//       sender: "user",
//     }
//     setMessages((prevMessages) => [...prevMessages, newMessage])
//     setLoading(true)

//     // Generate a contextual response based on user input
//     setTimeout(() => {
//       const botResponse = {
//         text: generateResponseForFeature(inputText),
//         sender: "bot",
//       }
//       setMessages((prevMessages) => [...prevMessages, botResponse])
//       // Start typing effect
//       setTypingEffect({
//         active: true,
//         text: "",
//         fullText: botResponse.text,
//         speed: 30,
//       })
//       speak(botResponse.text)
//       setInputText("")
//       setLoading(false)

//       // Wait a moment and then ask the next question
//       setTimeout(() => {
//         askNextQuestion()
//       }, 2500)
//     }, 1000)
//   }

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       sendMessage()
//     }
//   }

//   const clearChat = () => {
//     setMessages([])
//     setAskingName(true)
//     setUserName("")
//     setCurrentQuestionIndex(0)
//     setShowSuggestions(false)

//     // Add initial greeting again
//     const greetingMessage = {
//       text: "Hello! I am Ms.Kawan from VetLearn - your comprehensive learning platform for animal health and nutrition. What is your name?",
//       sender: "bot",
//     }
//     setMessages([greetingMessage])
//     // Start typing effect
//     setTypingEffect({
//       active: true,
//       text: "",
//       fullText: greetingMessage.text,
//       speed: 30,
//     })
//     speak(greetingMessage.text)
//   }

//   const handleSuggestionClick = (suggestion) => {
//     setInputText(suggestion)
//     setTimeout(() => {
//       sendMessage()
//     }, 100)
//   }

//   const toggleSpeech = () => {
//     if (isSpeaking) {
//       speechSynthesis.cancel()
//       setIsSpeaking(false)
//     } else {
//       // Find the last bot message and speak it
//       const lastBotMessage = [...messages].reverse().find((msg) => msg.sender === "bot")
//       if (lastBotMessage) {
//         speak(lastBotMessage.text)
//       }
//     }
//   }

//   // Bot avatar with animation
//   const BotAvatar = () => (
//     <div
//       className="bot-avatar"
//       style={{
//         width: "40px",
//         height: "40px",
//         borderRadius: "50%",
//         background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "relative",
//         overflow: "hidden",
//         boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//       }}
//     >
//       <div
//         style={{
//           width: "20px",
//           height: "20px",
//           borderRadius: "50%",
//           backgroundColor: "#fff",
//           position: "relative",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             width: "10px",
//             height: "10px",
//             background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//             borderRadius: "50%",
//             transform: "translate(-50%, -50%)",
//             animation: isSpeaking ? "pulse 1s infinite" : "none",
//           }}
//         />
//       </div>
//       <style jsx>{`
//         @keyframes pulse {
//           0% { transform: translate(-50%, -50%) scale(0.8); }
//           50% { transform: translate(-50%, -50%) scale(1.2); }
//           100% { transform: translate(-50%, -50%) scale(0.8); }
//         }
//       `}</style>
//     </div>
//   )

//   return (
//     <div
//       style={{
//         position: "fixed",
//         bottom: "0px",
//         right: "20px",
//         zIndex: 1000,
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       }}
//     >
//       {!isOpen && (
//         <div
//           style={{
//             background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//             color: "#ffffff",
//             padding: "15px",
//             borderRadius: "50%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             width: "60px",
//             height: "60px",
//             cursor: "pointer",
//             boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)",
//             transition: "transform 0.3s ease, box-shadow 0.3s ease",
//             animation: "bounce 2s infinite",
//           }}
//           onClick={toggleChat}
//           onMouseOver={(e) => {
//             e.currentTarget.style.transform = "scale(1.1)"
//             e.currentTarget.style.boxShadow = "0px 6px 20px rgba(0, 0, 0, 0.4)"
//           }}
//           onMouseOut={(e) => {
//             e.currentTarget.style.transform = "scale(1)"
//             e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.3)"
//           }}
//         >
//           <i className="fas fa-robot" style={{ fontSize: "24px" }}></i>
//           <style jsx>{`
//             @keyframes bounce {
//               0%, 100% { transform: translateY(0); }
//               50% { transform: translateY(-10px); }
//             }
//           `}</style>
//         </div>
//       )}

//       {isOpen && (
//         <div
//           style={{
//             width: "350px",
//             height: "550px",
//             background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//             boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.3)",
//             borderRadius: "15px",
//             overflow: "hidden",
//             display: "flex",
//             flexDirection: "column",
//             transition: "all 0.3s ease",
//             animation: "slideIn 0.3s ease-out",
//           }}
//         >
//           <style jsx>{`
//             @keyframes slideIn {
//               from { opacity: 0; transform: translateY(20px); }
//               to { opacity: 1; transform: translateY(0); }
//             }
//           `}</style>

//           <div
//             style={{
//               background: "rgba(0, 0, 0, 0.2)",
//               backdropFilter: "blur(10px)",
//               color: "#ffffff",
//               padding: "15px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               borderTopLeftRadius: "15px",
//               borderTopRightRadius: "15px",
//               boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <BotAvatar />
//               <div style={{ marginLeft: "10px" }}>
//                 <div style={{ fontWeight: "bold", fontSize: "16px" }}>VetLearn Assistant</div>
//                 <div style={{ fontSize: "12px", opacity: 0.8 }}>{isSpeaking ? "Speaking..." : "Online"}</div>
//               </div>
//             </div>
//             <div>
//               <button
//                 style={{
//                   backgroundColor: "rgba(255, 255, 255, 0.2)",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: "1em",
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "8px",
//                   transition: "background-color 0.2s ease",
//                 }}
//                 onClick={toggleSpeech}
//                 title={isSpeaking ? "Stop speaking" : "Speak message"}
//               >
//                 <i className={`fas ${isSpeaking ? "fa-volume-mute" : "fa-volume-up"}`}></i>
//               </button>
//               <button
//                 style={{
//                   backgroundColor: "rgba(255, 255, 255, 0.2)",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: "1em",
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "8px",
//                   transition: "background-color 0.2s ease",
//                 }}
//                 onClick={clearChat}
//                 title="Clear chat"
//               >
//                 <i className="fas fa-trash"></i>
//               </button>
//               <button
//                 style={{
//                   backgroundColor: "rgba(255, 255, 255, 0.2)",
//                   border: "none",
//                   color: "#ffffff",
//                   cursor: "pointer",
//                   fontSize: "1em",
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   transition: "background-color 0.2s ease",
//                 }}
//                 onClick={toggleChat}
//                 title="Close chat"
//               >
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>
//           </div>

//           <div
//             ref={chatContainerRef}
//             style={{
//               flexGrow: 1,
//               overflowY: "auto",
//               padding: "15px",
//               display: "flex",
//               flexDirection: "column",
//               background: "rgba(255, 255, 255, 0.9)",
//             }}
//           >
//             {messages.map((message, index) => (
//               <div
//                 key={index}
//                 style={{
//                   alignSelf: message.sender === "bot" ? "flex-start" : "flex-end",
//                   marginBottom: "15px",
//                   maxWidth: "80%",
//                   animation: "fadeIn 0.3s ease-out",
//                 }}
//               >
//                 {message.sender === "bot" && (
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "flex-end",
//                       marginBottom: "5px",
//                     }}
//                   >
//                     <BotAvatar />
//                     <div
//                       style={{
//                         fontSize: "0.8em",
//                         color: "rgb(184, 82, 158)",
//                         marginLeft: "5px",
//                         fontWeight: "bold",
//                       }}
//                     >
//                       Ms.Kawan
//                     </div>
//                   </div>
//                 )}
//                 <div
//                   style={{
//                     backgroundColor:
//                       message.sender === "bot"
//                         ? "#f5f5f5"
//                         : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//                     background:
//                       message.sender === "bot"
//                         ? "#f5f5f5"
//                         : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//                     color: message.sender === "bot" ? "#333333" : "#ffffff",
//                     padding: "12px 16px",
//                     borderRadius: "18px",
//                     borderTopLeftRadius: message.sender === "bot" ? "4px" : "18px",
//                     borderTopRightRadius: message.sender === "bot" ? "18px" : "4px",
//                     boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
//                     wordBreak: "break-word",
//                     position: "relative",
//                     fontSize: "14px",
//                     lineHeight: "1.5",
//                   }}
//                 >
//                   {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active
//                     ? typingEffect.text
//                     : message.text}
//                   {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active && (
//                     <span className="typing-indicator" style={{ marginLeft: "4px" }}>
//                       <span style={{ animation: "blink 1s infinite" }}>.</span>
//                       <span style={{ animation: "blink 1s infinite 0.2s" }}>.</span>
//                       <span style={{ animation: "blink 1s infinite 0.4s" }}>.</span>
//                       <style jsx>{`
//                         @keyframes blink {
//                           0%, 100% { opacity: 0.2; }
//                           50% { opacity: 1; }
//                         }
//                       `}</style>
//                     </span>
//                   )}
//                 </div>
//                 {message.sender === "user" && (
//                   <div
//                     style={{
//                       fontSize: "0.8em",
//                       color: "rgb(184, 82, 158)",
//                       marginTop: "5px",
//                       textAlign: "right",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     You
//                   </div>
//                 )}
//               </div>
//             ))}

//             {loading && (
//               <div
//                 style={{
//                   alignSelf: "flex-start",
//                   marginLeft: "10px",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 <BotAvatar />
//                 <div style={{ marginLeft: "10px" }}>
//                   <ThreeDots height="30" width="50" color="rgb(184, 82, 158)" ariaLabel="loading" />
//                 </div>
//               </div>
//             )}

//             {showSuggestions && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   gap: "8px",
//                   marginTop: "10px",
//                   marginBottom: "10px",
//                   animation: "fadeIn 0.5s ease-out",
//                 }}
//               >
//                 {suggestions.map((suggestion, index) => (
//                   <button
//                     key={index}
//                     onClick={() => handleSuggestionClick(suggestion)}
//                     style={{
//                       backgroundColor: "rgba(184, 82, 158, 0.1)",
//                       border: "1px solid rgba(184, 82, 158, 0.3)",
//                       borderRadius: "18px",
//                       padding: "8px 12px",
//                       fontSize: "13px",
//                       color: "rgb(184, 82, 158)",
//                       cursor: "pointer",
//                       transition: "all 0.2s ease",
//                     }}
//                     onMouseOver={(e) => {
//                       e.currentTarget.style.backgroundColor = "rgba(184, 82, 158, 0.2)"
//                     }}
//                     onMouseOut={(e) => {
//                       e.currentTarget.style.backgroundColor = "rgba(184, 82, 158, 0.1)"
//                     }}
//                   >
//                     {suggestion}
//                   </button>
//                 ))}
//                 <style jsx>{`
//                   @keyframes fadeIn {
//                     from { opacity: 0; transform: translateY(10px); }
//                     to { opacity: 1; transform: translateY(0); }
//                   }
//                 `}</style>
//               </div>
//             )}
//             <div ref={messagesEndRef} />
//           </div>

//           <div
//             style={{
//               padding: "15px",
//               backgroundColor: "rgba(255, 255, 255, 0.95)",
//               borderTop: "1px solid rgba(0, 0, 0, 0.1)",
//               boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.05)",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 borderRadius: "24px",
//                 padding: "5px 15px",
//                 backgroundColor: "#ffffff",
//                 border: "1px solid #e0e0e0",
//                 boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
//                 transition: "all 0.3s ease",
//               }}
//             >
//               <input
//                 type="text"
//                 value={inputText}
//                 onChange={(e) => setInputText(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 style={{
//                   border: "none",
//                   outline: "none",
//                   flexGrow: 1,
//                   backgroundColor: "transparent",
//                   padding: "12px 5px",
//                   fontSize: "14px",
//                 }}
//                 placeholder={askingName ? "Enter your name..." : "Type your message..."}
//               />
//               <button
//                 onClick={sendMessage}
//                 style={{
//                   background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)",
//                   color: "#ffffff",
//                   border: "none",
//                   borderRadius: "50%",
//                   width: "40px",
//                   height: "40px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginLeft: "10px",
//                   cursor: "pointer",
//                   boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
//                   transition: "all 0.2s ease",
//                 }}
//                 onMouseOver={(e) => {
//                   e.currentTarget.style.transform = "scale(1.05)"
//                   e.currentTarget.style.boxShadow = "0px 3px 8px rgba(0, 0, 0, 0.3)"
//                 }}
//                 onMouseOut={(e) => {
//                   e.currentTarget.style.transform = "scale(1)"
//                   e.currentTarget.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.2)"
//                 }}
//               >
//                 <i className="fas fa-paper-plane"></i>
//               </button>
//             </div>
//             <div
//               style={{
//                 textAlign: "center",
//                 fontSize: "0.75em",
//                 color: "rgb(184, 82, 158)",
//                 marginTop: "10px",
//                 opacity: 0.7,
//               }}
//             >
//               VetLearn - Empowering Learning. Enabling Growth. © 2025
//             </div>
//             <div
//               style={{
//                 textAlign: "center",
//                 fontSize: "0.7em",
//                 color: "#666",
//                 marginTop: "5px",
//               }}
//             >
//               <b>Contact: vetlearn@vetrinahealthcare.com | +91 8600844450</b>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default VetLearnChatbot



import { useState, useEffect, useRef } from "react";
import { ThreeDots } from "react-loader-spinner";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios"; // Added for PDF upload functionality

const VetLearnChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [askingName, setAskingName] = useState(true);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [typingEffect, setTypingEffect] = useState({ active: false, text: "", fullText: "", speed: 30 });
  
  // --- States for new functionality ---
  const [chatMode, setChatMode] = useState(null); // 'upload', 'ask', or null
  const [pdfId, setPdfId] = useState(null);
  
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);

  // VetLearn features data remains unchanged
  const vetLearnFeatures = {
    "Course Creation and Management": [
      "Creation of expert-designed modules tailored to real-world technical courses in dairy, poultry, sheep & goat, swine and companion animal health",
      "Modification of existing courses with practical, research-backed content from industry leaders",
      "Deletion of obsolete content to keep the platform relevant and updated with latest industry practices",
      "Preview feature to view courses from a learner's perspective before publishing to ensure quality delivery",
    ],
    "Learning Paths and Skill Development": [
      "Creation of personalized learning journeys for entrepreneurship, productivity, and sustainability in animal health industries",
      "Skill-based assessments and interactive modules designed to boost learner capabilities",
      "Flexibility to adjust learning paths based on individual career and business objectives",
      "Continuous upskilling programs for professional growth in livestock and companion animal sectors",
    ],
    "Progress Tracking and Analytics": [
      "Comprehensive tracking of learning progress, completion rates, and assessment results",
      "Data-driven insights to identify strengths, bridge gaps, and align learning with professional goals",
      "Performance analytics for both learners and administrators to monitor development",
      "Personalized recommendations based on learning patterns and career objectives",
    ],
    "Content Delivery and Accessibility": [
      "24/7 access to interactive training resources with user-friendly platform design",
      "Support for multiple content formats including practical case studies and research-driven materials",
      "Mobile-responsive interface ensuring seamless learning experience across all devices",
      "Integration with external tools and resources for comprehensive learning support",
    ],
    "Assessments and Certifications": [
      "Practical assessments based on real-world scenarios in animal healthcare and nutrition",
      "Professional certification programs recognized in the livestock and companion animal industry",
      "Skill-based evaluations aligned with industry standards and best practices",
      "Achievement recognition system to support career advancement and professional growth",
    ],
    "Community and Collaboration": [
      "Connect and communicate with peers to learn from everyone's experience",
      "Expert-led discussions and knowledge sharing sessions",
      "Collaborative learning environment fostering professional networking",
      "Access to industry professionals and seasoned experts for guidance and mentorship",
    ],
    "Entrepreneurship and Business Development": [
      "Entrepreneurial readiness programs for livestock and companion animal industry opportunities",
      "Business development modules focusing on making livestock farming simple and profitable",
      "Industry insights and market analysis for informed decision-making",
      "Practical business tools and case-based approaches for real-time problem solving",
    ],
    "Specialized Industry Focus": [
      "Comprehensive coverage of dairy, poultry, sheep & goat, swine, and companion animal health sectors",
      "Expert guidance from professionals with decades of hands-on experience",
      "Research-backed content supported by leading veterinary experts and industry practitioners",
      "Focus on enhancing pet health and happiness of pet parents in companion animal sector",
    ],
  }

  // Quick reply suggestions
  const suggestions = [
    "Course Access",
    "Learning Paths",
    "Certifications",
    "Industry Focus",
    "Entrepreneurship",
    "Progress Tracking",
  ]

  // Generate questions about VetLearn features
  const generateQuestions = () => {
    const questions = [
      `Hello ${userName}! Welcome to VetLearn - your gateway to animal health expertise. Which area interests you most: Dairy, Poultry, Companion Animals, or Entrepreneurship?`,
      `Great choice! What's your current role in the animal health industry? Are you a farmer, veterinarian, student, or looking to start your own venture?`,
      `${userName}, what specific skills would you like to develop? We offer practical training in animal nutrition, health management, or business development.`,
      `How important is hands-on, practical learning to you? Our courses are designed with real-world case studies and field experience.`,
      `Would you be interested in earning professional certifications that are recognized in the livestock and companion animal industry?`,
      `Are you looking to connect with other professionals and experts in the animal health field for collaborative learning?`,
      `What's your primary goal: enhancing your current skills, starting an animal health business, or advancing your career?`,
      `How do you prefer to learn? We offer 24/7 access with flexible scheduling, interactive modules, and expert-led sessions.`,
      `Would you like to track your progress and receive personalized recommendations based on your learning journey?`,
      `Are you interested in our specialized programs for making livestock farming more profitable and sustainable?`,
    ]
    return questions
  }

  // Generate detailed responses about VetLearn features
  const generateResponseForFeature = (feature) => {
    const featureResponses = {
      course:
        "VetLearn offers expert-designed courses tailored to real-world applications in dairy, poultry, sheep & goat, swine, and companion animal health. All content is backed by research and taught by industry professionals with decades of hands-on experience.",
      "learning path":
        "Our personalized learning paths are designed to build entrepreneurship, boost productivity, and ensure sustainability in animal health industries. We use data-driven insights to create customized journeys that align with your career and business objectives.",
      certification:
        "VetLearn provides professional certifications recognized in the livestock and companion animal industry. Our achievement recognition system supports career advancement and validates your expertise in animal healthcare and nutrition.",
      entrepreneurship:
        "We focus on building entrepreneurial readiness with comprehensive business development modules. Our goal is to make livestock farming simple and profitable while enhancing pet health and happiness of pet parents.",
      industry:
        "VetLearn specializes in dairy, poultry, sheep & goat, swine, and companion animal health sectors. Our content is developed by experts who blend veterinary sciences, animal nutrition, and business development expertise.",
      progress:
        "Our platform tracks learning progress, completion rates, and assessment results to offer personalized insights. These analytics help identify strengths, bridge gaps, and align learning with your professional goals.",
      practical:
        "Every course emphasizes practical outcomes with real-world case studies and research conducted by leading veterinary experts. We blend experience with evidence-based knowledge for meaningful learning that enhances on-the-job performance.",
      access:
        "VetLearn provides 24/7 access to interactive training resources through a secure, user-friendly platform. You can learn anytime, anywhere with our mobile-responsive interface and comprehensive learning support.",
      community:
        "Connect, communicate, and learn from peers while gaining insights from industry experts. Our collaborative environment fosters professional networking and knowledge sharing in the animal health community.",
      analytics:
        "We enable data-driven learning with comprehensive analytics that track your performance and provide personalized recommendations. This empowers both learners and administrators to make informed decisions about professional development.",
      support:
        "For any support or assistance, you can contact us at vetlearn@vetrinahealthcare.com or call us at +91 8600844450. Our team is always ready to help you with your learning journey.",
      contact:
        "You can reach out to us for support at vetlearn@vetrinahealthcare.com or call us at +91 8600844450. We're here to assist you with any questions about VetLearn platform and courses.",
      help: "Need help? Contact our support team at vetlearn@vetrinahealthcare.com or call +91 8600844450. We provide comprehensive support for all your learning needs on the VetLearn platform.",
      default:
        "VetLearn is a hybrid learning platform designed to transform animal health education. We offer comprehensive training in dairy, poultry, sheep & goat, swine, and companion animal sectors, focusing on practical skills, entrepreneurship, and professional growth. For support, contact us at vetlearn@vetrinahealthcare.com or +91 8600844450. How can I help you explore our specific features?",
    }

    const lowerFeature = feature.toLowerCase();
    for (const [key, response] of Object.entries(featureResponses)) {
      if (lowerFeature.includes(key)) {
        return response;
      }
    }
    return featureResponses.default;
  };

  // useEffect for typing effect remains unchanged
  useEffect(() => {
    if (typingEffect.active && typingEffect.text.length < typingEffect.fullText.length) {
      const timer = setTimeout(() => {
        setTypingEffect((prev) => ({
          ...prev,
          text: prev.fullText.substring(0, prev.text.length + 1),
        }));
      }, typingEffect.speed);
      return () => clearTimeout(timer);
    } else if (typingEffect.active && typingEffect.text.length === typingEffect.fullText.length) {
      setTypingEffect((prev) => ({ ...prev, active: false }));
      if (chatMode === 'ask' && !askingName && currentQuestionIndex === 1) {
        setShowSuggestions(true);
      }
    }
  }, [typingEffect, askingName, currentQuestionIndex, chatMode]);

  // useEffect for scrolling remains unchanged
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, typingEffect.text]);
  
  // useEffect for speech synthesis voices remains unchanged
  useEffect(() => {
    speechSynthesis.getVoices();
  }, []);

  const resetChatState = () => {
      setMessages([]);
      setAskingName(true);
      setUserName("");
      setCurrentQuestionIndex(0);
      setShowSuggestions(false);
      setChatMode(null);
      setPdfId(null);
      setInputText("");
      setLoading(false);
      if(isSpeaking) speechSynthesis.cancel();
      setIsSpeaking(false);
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      resetChatState();
      const initialMessage = {
          text: "Hello! I am Ms. Rina From Vetrina. Please select how you'd like to proceed.",
          sender: "bot",
          options: ["Upload Doc", "Ask Question"],
      };
      setMessages([initialMessage]);
      setTypingEffect({ active: true, text: "", fullText: initialMessage.text, speed: 30 });
      speak(initialMessage.text);
    }
  };
  
  const speak = (text) => {
    // ... speak function remains unchanged
    if (isSpeaking) speechSynthesis.cancel();
    setIsSpeaking(true);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    const voices = speechSynthesis.getVoices();
    const femaleVoice = voices.find(v => v.name.includes("Female") || v.name.includes("Google US English") || v.name.includes("Samantha"));
    if (femaleVoice) utterance.voice = femaleVoice;
    utterance.onend = () => setIsSpeaking(false);
    speechSynthesis.speak(utterance);
  };

  const handleOptionClick = (option) => {
    const userMessage = { text: option, sender: "user" };
    setMessages(prev => [...prev.map(m => ({...m, options: undefined})), userMessage]);

    if (option === "Upload Doc") {
        setChatMode('upload');
        const nextBotMessage = { text: "Great! Please upload your diagnostic PDF to get started.", sender: "bot" };
        setMessages(prev => [...prev, nextBotMessage]);
        setTypingEffect({ active: true, text: "", fullText: nextBotMessage.text, speed: 30 });
        speak(nextBotMessage.text);
    } else if (option === "Ask Question") {
        setChatMode('ask');
        const nextBotMessage = { text: "Hello! I am Ms.Rina from Vetrina. What is your name?", sender: "bot" };
        setMessages(prev => [...prev, nextBotMessage]);
        setTypingEffect({ active: true, text: "", fullText: nextBotMessage.text, speed: 30 });
        speak(nextBotMessage.text);
    }
  };

  const handleSwitchMode = () => {
      if (loading) return;
      const newMode = chatMode === 'upload' ? 'ask' : 'upload';
      const switchMessage = { text: `Switched to ${newMode === 'upload' ? 'Upload a Document' : 'General Q&A'} mode.`, sender: 'bot' };
      
      // Reset mode-specific state
      setPdfId(null); 
      setAskingName(true);
      
      setChatMode(newMode);
      setMessages(prev => [...prev, switchMessage]);

      if (newMode === 'upload') {
          const nextBotMessage = { text: "Please upload your diagnostic PDF to proceed.", sender: "bot" };
          setMessages(prev => [...prev, nextBotMessage]);
          speak(nextBotMessage.text);
      } else { // newMode is 'ask'
          const nextBotMessage = { text: "You can ask me anything about VetLearn. But first, what is your name?", sender: "bot" };
          setMessages(prev => [...prev, nextBotMessage]);
          speak(nextBotMessage.text);
      }
  }

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Keep a reference to the input element
    const fileInput = e.target;

    setMessages((prev) => [...prev, { text: `📂 ${file.name}`, sender: "user" }]);
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);
      const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/upload/", formData, { headers: { "Content-Type": "multipart/form-data" } });
      setPdfId(res.data?.pdf_id);
      const botMessage = { text: "✅ File uploaded! You can now ask questions about the document.", sender: "bot" };
      setMessages((prev) => [...prev, botMessage]);
      speak(botMessage.text);
    } catch (err) {
      const botMessage = { text: "❌ Upload failed. Please try again.", sender: "bot" };
      setMessages((prev) => [...prev, botMessage]);
      speak(botMessage.text);
    } finally {
      setLoading(false);
      // *** BUG FIX ***
      // Reset the file input's value here. This allows the user to re-select
      // the same file and trigger the onChange event again after a failure.
      if (fileInput) {
        fileInput.value = null;
      }
    }
  };

  const sendMessage = async () => {
    if (!inputText.trim()) return;
    const currentInput = inputText;
    setInputText("");

    if (chatMode === 'upload') {
        if (!pdfId) return;
        setMessages((prev) => [...prev, { text: currentInput, sender: "user" }]);
        try {
            setLoading(true);
            const res = await axios.post("https://tdtlworld.com/tatademo-backend/diagnostic/pdf/ask/", { pdf_id: pdfId, question: currentInput });
            const answer = typeof res.data === 'object' ? res.data.answer || JSON.stringify(res.data) : res.data;
            const botResponse = { text: answer || "I couldn't find an answer to that.", sender: "bot" };
            setMessages((prev) => [...prev, botResponse]);
            speak(botResponse.text);
        } catch (err) {
            const botMessage = { text: "❌ Failed to get an answer. Try again.", sender: "bot" };
            setMessages((prev) => [...prev, botMessage]);
            speak(botMessage.text);
        } finally {
            setLoading(false);
        }
    } else if (chatMode === 'ask') {
        setShowSuggestions(false);
        const userMessage = { text: currentInput, sender: "user" };
        setMessages(prev => [...prev, userMessage]);

        if (askingName) {
            setUserName(currentInput);
            setAskingName(false);
            setLoading(true);
            setTimeout(() => {
                const welcomeMessage = { text: `Nice to meet you, ${currentInput}! Welcome to VetLearn. How can I help you today?`, sender: "bot" };
                setMessages(prev => [...prev, welcomeMessage]);
                setTypingEffect({ active: true, text: "", fullText: welcomeMessage.text, speed: 30 });
                speak(welcomeMessage.text);
                setLoading(false);
                setTimeout(() => askNextQuestion(), 2000);
            }, 1000);
        } else {
            setLoading(true);
            setTimeout(() => {
                const botResponse = { text: generateResponseForFeature(currentInput), sender: "bot" };
                setMessages(prev => [...prev, botResponse]);
                setTypingEffect({ active: true, text: "", fullText: botResponse.text, speed: 30 });
                speak(botResponse.text);
                setLoading(false);
                setTimeout(() => askNextQuestion(), 2500);
            }, 1000);
        }
    }
  };
  
  const askNextQuestion = () => { /* ... unchanged ... */ };
  const handleKeyPress = (e) => { if (e.key === "Enter") sendMessage(); };
  const clearChat = () => { /* ... updated to call the new reset logic ... */
    resetChatState();
    const initialMessage = { text: "Chat cleared. How can I help you now?", sender: "bot", options: ["Upload Doc", "Ask Question"]};
    setMessages([initialMessage]);
    speak(initialMessage.text);
  };
  const handleSuggestionClick = (suggestion) => { /* ... unchanged ... */ };
  const toggleSpeech = () => { /* ... unchanged ... */ };

  const BotAvatar = () => (
    <div className="bot-avatar" style={{ width: "40px", height: "40px", borderRadius: "50%", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden", boxShadow: "0 2px 10px rgba(0,0,0,0.2)", }}>
      <div style={{ width: "20px", height: "20px", borderRadius: "50%", backgroundColor: "#fff", position: "relative", overflow: "hidden", }}>
        <div style={{ position: "absolute", top: "50%", left: "50%", width: "10px", height: "10px", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", borderRadius: "50%", transform: "translate(-50%, -50%)", animation: isSpeaking ? "pulse 1s infinite" : "none", }} />
      </div>
      <style jsx>{` @keyframes pulse { 0% { transform: translate(-50%, -50%) scale(0.8); } 50% { transform: translate(-50%, -50%) scale(1.2); } 100% { transform: translate(-50%, -50%) scale(0.8); } } `}</style>
    </div>
  );

  const renderInputArea = () => {
    if (!chatMode) return null;

    if (chatMode === 'upload' && !pdfId) {
        return (
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '45px', background: 'linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)', color: '#fff', borderRadius: '25px', cursor: 'pointer', fontWeight: 'bold' }}>
                <i className="fas fa-upload" style={{ marginRight: '10px' }}></i> Upload PDF
                <input type="file" accept="application/pdf" onChange={handleFileUpload} hidden />
            </label>
        );
    }
    
    let placeholder = "Type your message...";
    if (chatMode === 'ask' && askingName) placeholder = "Enter your name...";
    else if (chatMode === 'upload' && pdfId) placeholder = "Ask about the PDF...";

    return (
      <div style={{ display: "flex", alignItems: "center", borderRadius: "24px", padding: "5px 15px", backgroundColor: "#ffffff", border: "1px solid #e0e0e0", boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)", transition: "all 0.3s ease", }}>
        <input type="text" value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyPress={handleKeyPress} style={{ border: "none", outline: "none", flexGrow: 1, backgroundColor: "transparent", padding: "12px 5px", fontSize: "14px", }} placeholder={placeholder} />
        <button onClick={sendMessage} style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#ffffff", border: "none", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "10px", cursor: "pointer", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", transition: "all 0.2s ease", }} onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.05)"; e.currentTarget.style.boxShadow = "0px 3px 8px rgba(0, 0, 0, 0.3)"; }} onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0px 2px 5px rgba(0, 0, 0, 0.2)"; }}>
          <i className="fas fa-paper-plane"></i>
        </button>
      </div>
    );
  };


  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 1000, fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", }}>
      {!isOpen && (
        <div style={{ background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: "#ffffff", padding: "15px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", width: "60px", height: "60px", cursor: "pointer", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)", transition: "transform 0.3s ease, box-shadow 0.3s ease", animation: "bounce 2s infinite", }} onClick={toggleChat} onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.1)"; e.currentTarget.style.boxShadow = "0px 6px 20px rgba(0, 0, 0, 0.4)"; }} onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0, 0, 0, 0.3)"; }}>
          <i className="fas fa-robot" style={{ fontSize: "24px" }}></i>
          <style jsx>{` @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } } `}</style>
        </div>
      )}

      {isOpen && (
        <div style={{ width: "350px", height: "550px", background: "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.3)", borderRadius: "15px", overflow: "hidden", display: "flex", flexDirection: "column", transition: "all 0.3s ease", animation: "slideIn 0.3s ease-out", }}>
          <style jsx>{` @keyframes slideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } } `}</style>
          
          <div style={{ background: "rgba(0, 0, 0, 0.2)", backdropFilter: "blur(10px)", color: "#ffffff", padding: "15px", display: "flex", alignItems: "center", justifyContent: "space-between", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)", }}>
            <div style={{ display: "flex", alignItems: "center" }}> <BotAvatar /> <div style={{ marginLeft: "10px" }}> <div style={{ fontWeight: "bold", fontSize: "16px" }}>VetLearn Assistant</div> <div style={{ fontSize: "12px", opacity: 0.8 }}>{isSpeaking ? "Speaking..." : "Online"}</div> </div> </div>
            <div>
              <button style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", border: "none", color: "#ffffff", cursor: "pointer", fontSize: "1em", width: "30px", height: "30px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "8px", transition: "background-color 0.2s ease", }} onClick={toggleSpeech} title={isSpeaking ? "Stop speaking" : "Speak message"}> <i className={`fas ${isSpeaking ? "fa-volume-mute" : "fa-volume-up"}`}></i> </button>
              <button style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", border: "none", color: "#ffffff", cursor: "pointer", fontSize: "1em", width: "30px", height: "30px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", marginRight: "8px", transition: "background-color 0.2s ease", }} onClick={clearChat} title="Clear chat"> <i className="fas fa-trash"></i> </button>
              <button style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", border: "none", color: "#ffffff", cursor: "pointer", fontSize: "1em", width: "30px", height: "30px", borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", transition: "background-color 0.2s ease", }} onClick={toggleChat} title="Close chat"> <i className="fas fa-times"></i> </button>
            </div>
          </div>

          <div ref={chatContainerRef} style={{ flexGrow: 1, overflowY: "auto", padding: "15px", display: "flex", flexDirection: "column", background: "rgba(255, 255, 255, 0.9)", }}>
            {messages.map((message, index) => (
              <div key={index} style={{ alignSelf: message.sender === "bot" ? "flex-start" : "flex-end", marginBottom: "15px", maxWidth: "80%", animation: "fadeIn 0.3s ease-out", }}>
                {message.sender === "bot" && ( <div style={{ display: "flex", alignItems: "flex-end", marginBottom: "5px", }}> <BotAvatar /> <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginLeft: "5px", fontWeight: "bold", }}> Ms.Rina </div> </div> )}
                <div style={{ background: message.sender === "bot" ? "#f5f5f5" : "linear-gradient(120deg, rgb(255, 102, 0) 0%, rgb(184, 82, 158) 100%)", color: message.sender === "bot" ? "#333333" : "#ffffff", padding: "12px 16px", borderRadius: "18px", borderTopLeftRadius: message.sender === "bot" ? "4px" : "18px", borderTopRightRadius: message.sender === "bot" ? "18px" : "4px", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", wordBreak: "break-word", fontSize: "14px", lineHeight: "1.5", }}>
                  {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active ? typingEffect.text : message.text}
                  {message === messages[messages.length - 1] && message.sender === "bot" && typingEffect.active && ( <span className="typing-indicator" style={{ marginLeft: "4px" }}>...</span> )}
                </div>
                {message.sender === "bot" && message.options && (
                  <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {message.options.map((option, i) => ( <button key={i} onClick={() => handleOptionClick(option)} style={{ backgroundColor: "rgba(184, 82, 158, 0.1)", border: "1px solid rgba(184, 82, 158, 0.3)", borderRadius: "18px", padding: "8px 12px", fontSize: "13px", color: "rgb(184, 82, 158)", cursor: "pointer", transition: "all 0.2s ease", }}>{option}</button> ))}
                  </div>
                )}
                {message.sender === "user" && ( <div style={{ fontSize: "0.8em", color: "rgb(184, 82, 158)", marginTop: "5px", textAlign: "right", fontWeight: "bold", }}> You </div> )}
              </div>
            ))}
            {loading && ( <div style={{ alignSelf: "flex-start", display: "flex", alignItems: "center", }}><BotAvatar /><div style={{ marginLeft: "10px" }}><ThreeDots height="30" width="50" color="rgb(184, 82, 158)" /></div></div> )}
            {showSuggestions && ( <div style={{ /* ... styles for suggestions ... */ }}> {/* ... suggestions mapping ... */} </div> )}
            <div ref={messagesEndRef} />
          </div>

          <div style={{ padding: "10px 15px", backgroundColor: "rgba(255, 255, 255, 0.95)", borderTop: "1px solid rgba(0, 0, 0, 0.1)", boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.05)", }}>
            {renderInputArea()}
            {chatMode && (
                <div style={{ textAlign: 'center', marginTop: '8px' }}>
                    <button onClick={handleSwitchMode} style={{ background: 'transparent', border: 'none', color: 'rgb(184, 82, 158)', fontSize: '12px', cursor: 'pointer', opacity: 0.8 }}>
                        {chatMode === 'upload' ? 'Switch to General Q&A' : 'Switch to Upload PDF'}
                    </button>
                </div>
            )}
            <div style={{ textAlign: "center", fontSize: "0.7em", color: "#666", marginTop: "5px", }}> <b>Contact: vetlearn@vetrinahealthcare.com | +91 8600844450</b> </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VetLearnChatbot;